const mapData = {
  'tang-tret': {
    legend: [
      {
        title: 'THỂ THAO & RÈN LUYỆN THỂ CHẤT',
        child: [
          { id: 1, title: 'Hồ bơi muối khoáng Stellar 50m' },
          { id: 2, title: 'Hồ bơi thiên thần' },
          { id: 3, title: 'Sân Pickleball' },
        ],
      },
      {
        title: 'SỐNG LÀNH VÀ THƯ GIÃN',
        child: [
          { id: 5, title: 'Khu tập dưỡng sinh' },
          { id: 6, title: 'Sàn tắm nắng' },
        ],
      },
    ],
    hotspots: [
      {
        id: 1,
        x: 30,
        y: 40,
        title: 'Hồ bơi muối khoáng Stellar 50m',
        image: '/assets/images/interactive/sample.webp',
      },
      {
        id: 2,
        x: 50,
        y: 60,
        title: 'Hồ bơi thiên thần',
        image: '/assets/images/interactive/sample.webp',
      },
      {
        id: 3,
        x: 70,
        y: 45,
        title: 'Sân Pickleball',
        image: '/assets/images/interactive/sample.webp',
      },
      {
        id: 5,
        x: 35,
        y: 55,
        title: 'Khu tập dưỡng sinh',
        image: '/assets/images/interactive/sample.webp',
      },
      {
        id: 6,
        x: 65,
        y: 35,
        title: 'Sàn tắm nắng',
        image: '/assets/images/interactive/sample.webp',
      },
    ],
  },
  'khoi-podium': {
    legend: [
      {
        title: 'SỨC KHỎE & THỂ CHẤT',
        child: [
          { id: 1, title: 'Khu tập dưỡng sinh' },
          { id: 2, title: 'Sân làm vườn' },
        ],
      },
    ],
    hotspots: [
      {
        id: 1,
        x: 40,
        y: 50,
        title: 'Khu tập dưỡng sinh',
        image: '/assets/images/interactive/sample.webp',
      },
      {
        id: 2,
        x: 60,
        y: 40,
        title: 'Sân làm vườn',
        image: '/assets/images/interactive/sample.webp',
      },
    ],
  },
  rooftop: {
    legend: [
      {
        title: 'GIẢI TRÍ & THƯ GIÃN',
        child: [
          { id: 1, title: 'Khu vực BBQ' },
          { id: 2, title: 'Khu ngắm cảnh' },
        ],
      },
    ],
    hotspots: [
      {
        id: 1,
        x: 35,
        y: 45,
        title: 'Khu vực BBQ',
        image: '/assets/images/interactive/sample.webp',
      },
      {
        id: 2,
        x: 65,
        y: 55,
        title: 'Khu ngắm cảnh',
        image: '/assets/images/interactive/sample.webp',
      },
    ],
  },
};

export default mapData;
